import styled from '@emotion/styled';
import { Link } from '@mui/material';
import { color } from '@/theme/tokens';

type StyledLinkProps = {
    showUnderline?: boolean;
    component?: string;
};

export const StyledLink = styled(Link, {
    shouldForwardProp: (prop) => prop !== 'showUnderline',
})<StyledLinkProps>`
    text-decoration: ${({ showUnderline }) => (showUnderline ? 'underline' : 'none')};
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }

    &.brand {
        color: ${color.brand[50]};
    }

    &:focus-visible {
        outline: 2px solid ${color.gray[80]};
        outline-offset: 2px;
    }

    &.brand:focus-visible {
        outline-color: ${color.brand[60]};
    }
`;

// Fast Refresh ergonomics only, no runtime effect; splitting the file would churn every importer.
// react-doctor-disable-next-line only-export-components
export default StyledLink;
